import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/hooks/useTheme";
import { CursorGlow } from "@/components/CursorGlow";
import HomePage from "@/pages/HomePage";
import ServiceWizardPage from "@/pages/ServiceWizardPage";
import RodoPage from "@/pages/RodoPage";

function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-background text-foreground">
        <CursorGlow />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/zgloszenie" element={<ServiceWizardPage />} />
            <Route path="/zgloszenie-serwisowe" element={<ServiceWizardPage />} />
            <Route path="/rodo" element={<RodoPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </ThemeProvider>
  );
}

export default App;
